<template>
	<div class="row my-2">
		<div class="col-12 ">
			<div class="faqs-section__container shadow rounded-3 overflow-hidden">
				<template v-if="this.faqs?.length > 0">
					<details-unit
							v-for="faq in this.faqs"
							:title="faq?.question"
							:content="faq?.answer"
							:title-color="this.titleColor"
							:title-background="this.titleBackground"
							:content-background="this.contentBackground"
							:content-text-color="this.contentTextColor"
							:modules="faq.modules ?? []"
					/>
				</template>
			</div>

		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import InputUnit from "../Units/InputUnit.vue";
import DetailsUnit from "../Units/DetailsUnit.vue";

import VPlaceholder from "../VPlaceholder.vue";
import {Faq} from "../Interfaces/Faq";
import {InlineModuleInterface} from "../../Views/PageView/Interfaces/Components/InlineModuleInterface";

export default defineComponent({
	name: "FaqsSection",
	components: {VPlaceholder, DetailsUnit, InputUnit},

	props: {
		faqs: {
			type: Array as PropType<Faq[]>,
			default: []
		},
		titleColor: {
			type: String,
			default: "black",
			required: true
		},
		titleBackground: {
			type: String,
			default: "white",
			required: true
		},
		contentBackground: {
			type: String,
			default: "white",
			required: true
		},
		contentTextColor: {
			type: String,
			default: "black",
			required: true
		},
	},
});
</script>

<style lang="scss" scoped>
.shadow {
	box-shadow: 0 4px 6px rgba(255, 255, 255, 0.18);
}
</style>
